import { MantineThemeOverride } from '@mantine/core';

export type BackgroundImageTheme = NonNullable<MantineThemeOverride['components']>['BackgroundImage'];

export const BackgroundImage: BackgroundImageTheme = {
  // todo: define
};
